/**
 * Fire an analytics beacon for a click event.
 *
 * Uses `navigator.sendBeacon` so the request survives page navigation
 * (e.g. clicking an external link or `tel:` href).
 */
export function trackClick(
  tenantId: string,
  clickType: string,
  destination: string,
  options?: { label?: string; formName?: string; isConversion?: boolean },
) {
  const body = JSON.stringify({
    type: 'click' as const,
    path: typeof window !== 'undefined' ? window.location.pathname : '/',
    clickType,
    destination,
    label: options?.label,
    formName: options?.formName,
    isConversion: options?.isConversion,
  });

  const url = `/api/v0/tenants/${tenantId}/analytics`;

  if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
    navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
  } else if (typeof fetch !== 'undefined') {
    void fetch(url, { method: 'POST', body, headers: { 'Content-Type': 'application/json' }, keepalive: true });
  }
}
